import { render, staticRenderFns } from "./blockGroup.vue?vue&type=template&id=a2448dd4&"
import script from "./blockGroup.vue?vue&type=script&lang=js&"
export * from "./blockGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports